import React, { ReactNode, forwardRef } from 'react';
import { CSSProperties } from 'styled-components';

interface Props {
  fluid?: boolean;
  className?: string;
  style?: CSSProperties;
  children: ReactNode;
}

const Container = forwardRef<HTMLDivElement, Props>((props, ref) => {
  const { fluid, className, children, ...rest } = props;
  return (
    <div
      className={`${fluid ? 'container-fluid' : 'container'} ${className || ''}`}
      ref={ref}
      {...rest}
    >
      {children}
    </div>
  );
});

export default Container;
